import { colorHexFor } from '../lib/colors';
import type { ColorTag } from '../lib/api';

/**
 * Thin reusable color stripe sized per use site.
 *
 * Per ARCH §9: 4px on top nav, 12px on the Notes page chrome, plus 4px
 * left-edge stripes on list items (Build D). Color comes from
 * projects.color_tag — see lib/colors.ts for placeholder hex values.
 */
export function ProjectColorBar({
  color,
  height = 4,
  className = '',
}: {
  color: ColorTag | null | undefined;
  height?: number;
  className?: string;
}) {
  return (
    <div
      className={className}
      style={{ height: `${height}px`, background: colorHexFor(color) }}
      aria-hidden
    />
  );
}
